import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import ShareableLinkLockScreen from '../ShareableLinkLockScreen';

import './ShareableLinkRejectedFromWaitingRoom.styles.scss';

type ShareableLinkRejectedFromWaitingRoomProps = {
  className?: string;
};

const ShareableLinkRejectedFromWaitingRoom: React.FC<
  ShareableLinkRejectedFromWaitingRoomProps
> = (props) => {
  const { className } = props;

  const classes = classNames(
    'shareable-link-rejected-from-waiting-room',
    className,
  );

  const { t } = useTranslation();

  return (
    <ShareableLinkLockScreen
      className={classes}
      title={t('youAreNotGrantedPermissionAccessLink')}
    />
  );
};

export default ShareableLinkRejectedFromWaitingRoom;
